import { render } from "./messageComponent.vue?vue&type=template&id=17ad7dca&ts=true"
import script from "./messageComponent?vue&type=script&lang=ts"
export * from "./messageComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__